<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :height="`${height}px`"
    :viewBox="`0 0 ${width} ${height}`"
    :width="`${width}px`"
    class="area"
  >
    <g>
      <rect
        x="0"
        y="0"
        :width="width"
        :height="height"
        style="fill: none; opacity: 0.4;"
      />
    </g>

    <g>
      <g>
        <g>
          <path
            style="stroke: rgb(105, 114, 222); opacity: 1; fill: none;"
            :d="lineD"
          />
        </g>
        <g>
          <path
            style="fill: rgb(105, 114, 222); opacity: 0.1;"
            :d="areaD"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
import { random } from 'lodash';

export default {
  name: 'chart-wrapper',
  props: {
    width: {
      type: [String, Number],
      default: 135,
    },
    height: {
      type: [String, Number],
      default: 24,
    },
  },
  data() {
    return {
      lineD: null,
      areaD: null,
    };
  },
  created() {
    this.generateRandomData();
  },
  methods: {
    generateRandomData() {
      const xQty = random(25, 35);

      const h = this.height;
      const w = this.width;

      const numbers = Array.from(Array(99), (_, i) => i + 1);
      let xValues = [0];

      for (let n = 1; n <= xQty; ++n) {
        const i = Math.floor((Math.random() * (99 - n)) + 1);
        xValues.push(numbers[i]);
        numbers[i] = numbers[99 - n];
      }

      xValues.push(100);

      xValues = xValues.sort((a, b) => a - b);

      const yValues = [];

      xValues.forEach(x => {
        if (yValues.length === 0) yValues.push(random(35, 65));
        else {
          const gap = random(5, 35);
          const last = yValues[yValues.length - 1];
          const minRandom = ((last - gap) <= 0) ? 0 : (last - gap);
          const maxRandom = ((last + gap) >= 100) ? 100 : (last + gap);
          yValues.push(random(minRandom, maxRandom));
        }
      });

      this.lineD = '';

      xValues.forEach((x, i) => {
        if (i === 0) this.lineD += `M${w / 100 * x},${h / 100 * yValues[i]}`;
        else this.lineD += `L${w / 100 * x},${h / 100 * yValues[i]}`;
      });

      this.areaD = this.lineD;

      xValues.slice().reverse().forEach((x, i) => {
        this.areaD += `L${w / 100 * x},${h}`;
        if (i === xValues.length - 1) this.areaD += 'Z';
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.area {
  display: inline-block;
  vertical-align: middle;
}
</style>
